import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import intl from 'react-intl-universal'
import { Grid, Popover, Toast, Button, AutoCenter, Popup } from 'antd-mobile'
import { getLanguageStore } from '../../../utils/storage/language'
import { getIconByStoreIdModel, getStoreInfoByIdModel, getActivityNextModel } from '../../../model/store'
import { replaceCDNDomain, formatJSON } from '../../../utils'
import { shouldGoNext } from '../../../utils/bookRule'
import { geOwnDomain } from '../../../utils/page'
import { getScopeParam } from '../../../utils/session/store'
import { addBehaviorsRecord } from '../../../utils/BehaviorstatsHelp'
import { getProductMenuModel, getServiceInfoModal } from '../../../model/store'
import { setProductModalVisible, selectProductModalVisible, selectJmModalVisible, setJmModalVisible } from '../../../store/reducers/hotel'
import ProductModal from '../ProductModal'
import JmModal from '../../../components/JmModal'
import PopupContent from '../../../components/PopupContent'
import KeepAlivePopup from '../../../components/KeepAlivePopup'
import PromotionDetail from '../../../components/PromotionList/Detail'
import BookForm from '../../activity/BookForm'
import styles from './index.module.less'
import FacilityDetail from '../../facility/detail'

import NoIcon from '../../../components/Icon/NoIcon'

// 自定义hook用于处理加载状态
const useLoading = () => {
    const handler = useRef(null)

    const showLoading = (message = 'loading...') => {
        handler.current = Toast.show({
            icon: 'loading',
            content: message,
            duration: 0
        })
    }

    const hideLoading = () => {
        handler.current?.close()
    }

    return { showLoading, hideLoading }
}

// 自定义hook用于处理图标数据
const useIconData = (storeInfo) => {
    const [iconList, setIconList] = useState([])
    const [ids, setIds] = useState([])

    useEffect(() => {
        const { partnerId, roomTypeId } = storeInfo
        if (!partnerId) return
        getIconByStoreIdModel({ storeId: partnerId }).then(res => {
            const newIds = []
            const newList = []
            res.forEach(item => {
                let isShow = true
                const { extendColumn } = item
                const extendObj = formatJSON(extendColumn)
                if (extendObj && extendObj.notApplicableRoomTypeIds) {
                    const notApplicableRoomTypeIds = extendObj.notApplicableRoomTypeIds.split(',').map(id => parseInt(id))
                    isShow = !notApplicableRoomTypeIds.includes(roomTypeId)
                }
                if (isShow && item.relateType === 3) {
                    const arr = item.relateId.split(',').map(id => parseInt(id))
                    newIds.push(...arr)
                }
                if (isShow) {
                    newList.push(item)
                }
            })
            setIconList(newList.sort((a, b) => b.sort - a.sort))
            setIds(newIds)
        }).catch(err => {
            console.log(err)
        })
    }, [storeInfo])

    return { iconList, ids }
}

const IconName = React.memo(({ iconData, name }) => {
    return getIconName({ iconData, name })
})

const getIconName = ({ iconData, name }) => {
    const { globalizeList } = iconData || {}
    const obj = globalizeList?.find(item => item.language === getLanguageStore())
    return obj ? obj.value : name || ''
}

const SubCategoryGrid = React.memo(({ childList, onItemClick }) => {
    const [subImageErrors, setSubImageErrors] = useState({})

    return (
        <div className={`${styles.iconGrid}`} style={{ padding: '10px 0' }}>
            <Grid columns={childList.length > 4 ? 4 : childList.length} gap={8}>
                {childList.map((iconData, index) => (
                    <Grid.Item key={index}>
                        <div className={`${styles.iconGridItem}`} onClick={() => onItemClick(iconData)}>
                            <div className={styles.iconBg}>
                                {subImageErrors[`sub-${iconData.id}`] ? (
                                    <NoIcon width={34} height={34} color='var(--adm-color-primary)' />
                                ) : (
                                    <img
                                        src={replaceCDNDomain(iconData.imageUrl)}
                                        alt='icon'
                                        onError={() => {
                                            setSubImageErrors(prev => ({ ...prev, [`sub-${iconData.id}`]: true }))
                                        }}
                                    />
                                )}
                            </div>
                            <div className={`${styles.iconName} ellips_line2`}>
                                <IconName iconData={iconData} name={iconData.name} />
                            </div>
                        </div>
                    </Grid.Item>
                ))}
            </Grid>
        </div>
    )
})

export default function IconGrid({ storeInfo }) {
    const [activePopoverId, setActivePopoverId] = useState(null)
    const [selectChildList, setSelectChildList] = useState([])
    const [curIconData, setCurIconData] = useState({})
    const [product, setProduct] = useState({})
    const [orderId, setOrderId] = useState('')
    const [activeIconPosition, setActiveIconPosition] = useState(null)
    const [bookFormVisible, setBookFormVisible] = useState(false)

    const [actDetail, setActDetail] = useState(null)
    const [serviceItem, setServiceItem] = useState(null)
    const [imageErrors, setImageErrors] = useState({})

    const iconGridRef = useRef(null)

    const { showLoading, hideLoading } = useLoading()
    const { iconList, ids } = useIconData(storeInfo)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const productModalVisible = useSelector(selectProductModalVisible)
    const jmModalVisible = useSelector(selectJmModalVisible)

    const { areaId, name, area, partnerId } = getScopeParam() || {}

    const addBehaviorLog = useCallback(({ item, text }) => {
        addBehaviorsRecord({
            behaviorType: 160200,
            behavior: 160203,
            storeId: storeInfo.storeId,
            value1: item.name,
            value2: text
        })
    }, [storeInfo.storeId])

    const handleOrderSuccess = useCallback((orderId) => {
        setOrderId(orderId)
        dispatch(setJmModalVisible(true))
    }, [dispatch])

    const handleViewOrderDetail = useCallback(() => {
        dispatch(setJmModalVisible(false))
        navigate('/order/detail?id=' + orderId)
    }, [dispatch, navigate, orderId])

    const showProductModal = useCallback(async (item) => {
        setCurIconData(item)
        showLoading()
        try {
            const res = await getProductMenuModel({ productId: item.relateId })
            setProduct(res)
            const flag = shouldGoNext(res)
            if (flag) {
                //setBookFormVisible(true)
                //return
            }

            dispatch(setProductModalVisible(true))
        } catch (msg) {
            Toast.show({
                icon: 'fail',
                content: msg?.returnMsg || 'Network Error'
            })
        } finally {
            hideLoading()
        }
    }, [dispatch, showLoading, hideLoading])

    const goToStorePage = useCallback(async (item) => {

        if (item.type === 2) {
            navigate(`/carte?areaid=${areaId}&partnerid=${partnerId}&hotel=${name}&storeid=${item.relateId}`)
            addBehaviorLog({ item, text: '/carte' })
            return
        }

        showLoading()
        try {
            const res = await getStoreInfoByIdModel({ storeId: item.relateId })
            const domain = geOwnDomain()
            const text = `areaid=${areaId}&partnerid=${partnerId}&hotel=${name}&storeid=${res.storeId}`

            const navigationMap = {
                7: () => navigate(`/restaurant?${text}`),
                1: () => navigate(`/catering?${text}`),
                9: () => navigate(`/catering?${text}`),
                3: () => navigate(`/spa?${text}`),
                10: () => navigate(`/activity?${text}`),
                11: () => {
                    const view = '#home'
                    const param = `?room=${area}&hotel=${name}&member=${partnerId}`
                    const href = `${domain.tour}/${view}${param}&from=hotel&back=${encodeURIComponent(window.location.href)}&lang=${getLanguageStore()}`
                    window.location.href = href
                },
                2: () => navigate(`/carte?${text}`),
                6: () => navigate(`/carte?${text}`),
                12: () => navigate(`/carte?${text}`),
                99: () => navigate(`/facility?partnerid=${partnerId}`),
                100: () => navigate('/feedback'),
                101: () => navigate(`/facility?partnerid=${partnerId}&type=3`),
                14: () => navigate(`/souvenir?areaid=${areaId}&storeid=${res.storeId}`),
                15: () => navigate(`/voucher?areaid=${areaId}&storeid=${res.storeId}`)
            }

            const navigateAction = navigationMap[res.type]
            if (navigateAction) {
                if (res.type === 11) {
                    addBehaviorLog({ item, text: 'to jimu tour website' })
                } else {
                    const actionString = navigateAction.toString()

                    // 匹配反引号中的内容（不依赖函数名）
                    const templateMatch = actionString.match(/`([^`]+)`/)

                    if (templateMatch) {
                        const fullPath = templateMatch[1]
                        // 提取路径部分（问号之前的内容）
                        const path = fullPath.split('?')[0]
                        console.log('路径值:', path) // 例如: /carte 或 /souvenir

                        // 如果需要，可以在这里使用 path 值
                        addBehaviorLog({ item, text: path })
                    }
                }

                navigateAction()
            }
        } catch (msg) {
            Toast.show({
                icon: 'fail',
                content: msg?.returnMsg || 'Network Error'
            })
        } finally {
            hideLoading()
        }
    }, [areaId, partnerId, name, area, navigate, showLoading, hideLoading])

    const handleIconClick = useCallback((item, childList, event) => {
        setProduct(null)
        const fName = getIconName({ iconData: item, name: item.name })
        // 获取点击元素的位置信息
        if (event) {
            const rect = event.currentTarget.getBoundingClientRect()
            const gridRect = iconGridRef.current.getBoundingClientRect()
            setActiveIconPosition({
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height,
                iconData: item,
                gridTop: gridRect.top,
                gridLeft: gridRect.left
            })
        }


        const actionMap = {
            1: () => goToStorePage(item),
            2: () => {
                const facilityUrl = (type) => `/facility?partnerid=${partnerId}${type ? `&type=${type}` : ''}&fname=${encodeURIComponent(fName)}`

                const navigationMap = {
                    1: () => navigate(facilityUrl()),
                    2: () => navigate(facilityUrl(3)),
                    4: () => navigate(facilityUrl(4)),
                    3: () => navigate(`/feedback?partnerid=${partnerId}&fname=${fName}`),
                    5: () => {
                        //js_promote_wrapper
                        const promoteWrapper = document.querySelector('.js_promote_wrapper')
                        if (promoteWrapper) {
                            promoteWrapper.scrollIntoView({ behavior: 'smooth' })
                            // add behavior log
                            addBehaviorLog({ item, text: 'scroll to promotion item' })
                        }
                    }
                }

                // add behavior log
                if ([1, 2, 4].includes(Number(item.relateId))) {
                    addBehaviorLog({ item, text: '/facility' })
                } else if (item.relateId === '3') {
                    addBehaviorLog({ item, text: '/feedback' })
                }


                navigationMap[Number(item.relateId)]?.()
            },
            3: () => {
                if (activePopoverId === item.id) {
                    setActivePopoverId(null)
                    setSelectChildList([])
                    setActiveIconPosition(null)
                    return
                }
                if (childList?.length > 0) {
                    setActivePopoverId(item.id)
                    setSelectChildList(childList)
                }
            },
            4: () => {
                showLoading()
                getActivityNextModel({
                    areaId,
                    partnerId: item.storeId,
                    activityId: item.relateId,
                    relateTypes: '801,802',
                    curLanguage: getLanguageStore() || 'en_US',
                }).then(res => {
                    console.log(res)
                    hideLoading()
                    if (res.length === 0) return;

                    setActDetail({ ...res[0], placeFlag: 4 })

                    addBehaviorLog({ item, text: 'show promotion detail page' })

                })

            },
            5: () => {
                let text = ''
                if (item.type === 2) {
                    text = 'show product modal'
                    showProductModal(item)
                } else {
                    text = 'navigate to relate product page'
                    navigate(`/relate-product?productId=${item.relateId}`, { state: { iconData: item } })
                }
                addBehaviorLog({ item, text })
            },
            6: () => {
                navigate(`/feedback?partnerid=${partnerId}`)
                addBehaviorLog({ item, text: '/feedback' })
            },
            8: () => {
                showLoading()
                getServiceInfoModal({
                    serviceId: item.relateId,
                    curLanguage: getLanguageStore() || 'en_US',
                }).then(res => {
                    console.log(res)
                    hideLoading()
                    setServiceItem(res)
                    addBehaviorLog({ item, text: 'show facility detail page' })
                })
            }
        }
        const action = actionMap[item.relateType]
        if (action) action()
    }, [goToStorePage, activePopoverId, partnerId, navigate, showProductModal, areaId, showLoading, hideLoading, setServiceItem])

    const renderPopover = useCallback((childList) => (
        <SubCategoryGrid
            childList={childList}
            onItemClick={(item) => {
                handleIconClick(item)
                setActivePopoverId(null)
            }}
        />
    ), [handleIconClick])

    return (
        <div className={`${styles.iconGrid}`} ref={iconGridRef} style={{ position: 'relative' }}>
            {activePopoverId && (
                <>
                    <div
                        className={styles.mask}
                        onClick={() => {
                            setActivePopoverId(null)
                            setSelectChildList([])
                            setActiveIconPosition(null)
                        }}
                    />
                    {activeIconPosition && (
                        <div
                            className={styles.activeIcon}
                            style={{
                                position: 'absolute',
                                top: activeIconPosition.top - activeIconPosition.gridTop,
                                left: activeIconPosition.left - activeIconPosition.gridLeft,
                                width: activeIconPosition.width,
                                height: activeIconPosition.height,
                                zIndex: 1001
                            }}
                        >
                            <div className={`${styles.iconGridItem}`}>
                                <div className={styles.iconBg}>
                                    {imageErrors[`icon-active-${activeIconPosition.iconData.id}`] ? (
                                        <NoIcon width={34} height={34} color='#418379' />
                                    ) : (
                                        <img
                                            src={activeIconPosition.iconData.imageUrl}
                                            alt='icon'
                                            onError={() => {
                                                setImageErrors(prev => ({ ...prev, [`icon-active-${activeIconPosition.iconData.id}`]: true }))
                                            }}
                                        />
                                    )}
                                </div>
                                <div className={`${styles.iconName} ${styles.subIconName} ellips_line21`}>
                                    <IconName iconData={activeIconPosition.iconData} name={activeIconPosition.iconData.name} />
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
            <Grid columns={4} gap={10}>
                {iconList.map((item, index) => {
                    let iconData = item
                    let arr = []
                    if (item.relateType === 3) {
                        item.relateId.split(',').forEach(id => {
                            const obj = iconList.find(item => item.id === parseInt(id))
                            if (obj) arr.push(obj)
                        })
                        if (arr.length === 0) {
                            iconData = arr[0]
                        }
                    }

                    if (!iconData) return null
                    if (ids.includes(iconData?.id)) {
                        return null
                    }


                    return (
                        <div key={index}>
                            {arr.length === 0 && !ids.includes(iconData?.id) ? (
                                <Grid.Item>
                                    <div className={`${styles.iconGridItem}`} onClick={(event) => handleIconClick(iconData, [], event)}>
                                        {imageErrors[`icon-${iconData.id}`] ? (
                                            <NoIcon width={34} height={34} color='#418379' />
                                        ) : (
                                            <img
                                                src={replaceCDNDomain(iconData?.imageUrl)}
                                                alt='icon'
                                                onError={() => {
                                                    setImageErrors(prev => ({ ...prev, [`icon-${iconData.id}`]: true }))
                                                }}
                                            />
                                        )}
                                        <div className={`${styles.iconName} ellips_line2`}>
                                            <IconName iconData={iconData} name={iconData.name} />
                                        </div>
                                    </div>
                                </Grid.Item>
                            ) : (
                                <Popover
                                    visible={activePopoverId === iconData.id}
                                    content={renderPopover(arr)}
                                    trigger='click'
                                    placement='top-start'
                                    showMask={true}
                                    maskClassName={styles.popoverMask}
                                    onVisibleChange={(visible) => {
                                        if (!visible) {
                                            setActivePopoverId(null)
                                            setSelectChildList([])
                                        }
                                    }}
                                >
                                    <div className={`${styles.iconGridItem}`} onClick={(event) => handleIconClick(iconData, arr, event)}>
                                        {imageErrors[`icon-popover-${iconData.id}`] ? (
                                            <NoIcon width={34} height={34} color='#418379' />
                                        ) : (
                                            <img
                                                src={replaceCDNDomain(iconData.imageUrl)}
                                                alt='icon'
                                                onError={() => {
                                                    setImageErrors(prev => ({ ...prev, [`icon-popover-${iconData.id}`]: true }))
                                                }}
                                            />
                                        )}
                                        <div className={`${styles.iconName} ellips_line2`}>
                                            <IconName iconData={iconData} name={iconData.name} />
                                        </div>
                                    </div>
                                </Popover>
                            )}
                        </div>
                    )
                })}
            </Grid>

            {productModalVisible && product && (
                <ProductModal
                    product={product}
                    iconData={curIconData}
                    onCallback={handleOrderSuccess}
                    showExtendForm={true}
                    headStoreInfo={storeInfo}
                />
            )}

            {orderId && jmModalVisible && (
                <JmModal iconData={curIconData}>
                    <div className={'p10 text-center'}>
                        <div className='fs-18 txt-primary'>
                            {intl.get('orderNumber').d('订单ID')}&nbsp;{orderId}
                        </div>
                        <br />
                        <div className='fs-14 text-gray'>
                            <AutoCenter>{product.bookingResultReminderMessage || 'Booking success...'}</AutoCenter>
                        </div>
                        <br />
                        <div>
                            <Button
                                size='small'
                                className={`m-t-sm jm-btn ${styles.footerBtn}`}
                                onClick={handleViewOrderDetail}
                            >
                                {intl.get('lookDetail').d('查看详情')}
                            </Button>
                        </div>
                    </div>
                </JmModal>
            )}

            {
                product && bookFormVisible && (
                    <Popup
                        visible={bookFormVisible}
                        onClose={() => { setBookFormVisible(false) }}
                        destroyOnClose>
                        <PopupContent>
                            <BookForm
                                item={product}
                                callback={() => { setBookFormVisible(false) }}
                                nextAction={() => { setBookFormVisible(false) }} />
                        </PopupContent>
                    </Popup>
                )
            }

            {/* 详情弹窗 */}
            {actDetail && (
                <KeepAlivePopup
                    visible={!!actDetail}
                    onClose={() => setActDetail(null)}
                    position='bottom'
                >
                    <PopupContent>
                        <PromotionDetail
                            detail={{ ...actDetail, placeFlag: 1 }}
                            callback={() => setActDetail(null)}
                        />
                    </PopupContent>
                </KeepAlivePopup>
            )}

            {/* 服务详情弹窗 */}
            {serviceItem && (
                <KeepAlivePopup
                    visible={!!serviceItem}
                    onClose={() => setServiceItem(null)}
                    position='bottom'
                >
                    <PopupContent>
                        <FacilityDetail
                            item={serviceItem}
                            callback={() => setServiceItem(null)}
                        />
                    </PopupContent>
                </KeepAlivePopup>
            )}
        </div>
    )
}